import { createSelector } from 'reselect';

const getMessages = (state) => state.inbox.concat(state.outbox);

const getId = (state, id) => id;

export const getInboxMessageByID = createSelector(getMessages, getId, (messages, id) =>
  messages.find((messageItem) => messageItem.id.toString() === id.toString()),
);
